/**
 * Trim and lowercase an excluded-email-domain string (for display and submit).
 */
const normalizeExcludedEmailDomain = (raw: string): string =>
  raw.trim().toLowerCase();

export default normalizeExcludedEmailDomain;
